import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import FacebookAdsAccountsReport from './FacebookAdsAccountsReport';
import EnhancedFacebookAdsTable from './facebook-ads-table';

const FacebookAdsTabs = () => {
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const initialTab = params.get('tab') || 'accounts';
  const [activeTab, setActiveTab] = useState(initialTab);

  // Sync with url if changed externally
  useEffect(() => {
    const p = new URLSearchParams(location.search);
    const t = p.get('tab') || 'accounts';
    if (t !== activeTab) setActiveTab(t);
  }, [location.search, activeTab]);

  const changeTab = (tab) => {
    if (tab === activeTab) return;
    const p = new URLSearchParams(location.search);
    p.set('tab', tab);
    history.push({ pathname: location.pathname, search: p.toString() });
    setActiveTab(tab);
  };

  return (
    <div className='facebook-ads-tabs-container'>
      <div className='tabs mb-4'>
        <button
          className={`tab-btn ${activeTab === 'accounts' ? 'active' : ''}`}
          onClick={() => changeTab('accounts')}
        >
          Accounts Report
        </button>
        <button
          className={`tab-btn ${activeTab === 'campaigns' ? 'active' : ''}`}
          onClick={() => changeTab('campaigns')}
        >
          Campaigns Report
        </button>
      </div>
      {activeTab === 'accounts' && <FacebookAdsAccountsReport />}
      {activeTab === 'campaigns' && <EnhancedFacebookAdsTable />}
      <style jsx>{`
        .tabs {
          display: flex;
          gap: 12px;
        }
        .tab-btn {
          padding: 8px 24px;
          border: none;
          border-radius: 8px;
          background: #f1f5f9;
          color: #1877f2;
          font-weight: 600;
          cursor: pointer;
        }
        .tab-btn.active {
          background: #1877f2;
          color: #fff;
        }
      `}</style>
    </div>
  );
};

export default FacebookAdsTabs;
